<template>
  <div>
    <div  v-if="service_estimate" class="md-layout noprint ">
      <v-toolbar
        :src="require('@/assets/images/vuebackground.jpg')"
        style="transform: translateY(0)"
      >
        <v-spacer></v-spacer>
        <v-menu :close-on-content-click="false" open-on-hover bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              v-on="on"
            >
              <span style="color:white">Options</span>
            </v-btn>
          </template>
    
          <v-list class="noprint">
            <v-list-item @click="printPage()" ><v-list-item-title>Print</v-list-item-title></v-list-item>
            
            <v-list-group
              v-if="service_estimate.service_estimate_status!=2 && service_estimate.service_estimate_status!=3"
            >
              <template v-slot:activator>
                <v-list-item
                >
                  <v-list-item-title>Change Status</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item v-if="service_estimate.service_estimate_status==0 && role.requester" class="noprint" @click="updateStatusConfirmation('Request Approval')"><v-list-item-title>Request Approval</v-list-item-title></v-list-item>
              <v-list-item v-if="service_estimate.service_estimate_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation('Approve')"><v-list-item-title>Approve</v-list-item-title></v-list-item>
              <v-list-item v-if="service_estimate.service_estimate_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation('Reject', true)"><v-list-item-title>Reject</v-list-item-title></v-list-item>
            </v-list-group>
          </v-list>
        </v-menu>
        <!-- <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon class="noprint " @click="printPage()" ><md-icon style="color:white;">print</md-icon></v-btn>
            <v-btn
              v-bind="attrs"
              v-on="on"
              text
              small
              v-if="service_estimate.service_estimate_status!=2 && service_estimate.service_estimate_status!=3"
            >
              <span style="color:white;">Change Status</span>
            </v-btn>
            
          </template>
          <v-list>
            <v-list-item v-if="service_estimate.service_estimate_status==0 && role.requester" class="noprint" @click="updateStatusConfirmation('Request Approval')">Request Approval</v-list-item>
            <v-list-item v-if="service_estimate.service_estimate_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation('Approve')">Approve</v-list-item>
            <v-list-item v-if="service_estimate.service_estimate_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation('Reject', true)">Reject</v-list-item>
          </v-list>
        </v-menu> -->
        <v-btn icon @click="closeDetail()">
          <v-icon style="color:white;">mdi-export</v-icon>
        </v-btn>

        <template v-slot:extension>
            <v-toolbar-title style="color:white;">
              <p v-if="service_estimate.service_estimate_status==0" style="text-align: left; font-weight:bold;">REGISTERED</p>
              <p v-if="service_estimate.service_estimate_status==1" style="text-align: left; font-weight:bold;">WAITING APPROVAL</p>
              <p v-if="service_estimate.service_estimate_status==2" style="text-align: left; font-weight:bold;">APPROVED</p>
              <p v-if="service_estimate.service_estimate_status==3" style="text-align: left; font-weight:bold;">REJECTED</p>
            </v-toolbar-title>
        </template>
      </v-toolbar>

      <!-- <md-toolbar class="color md-dense" style="width:100%">
        <div style="width:50%">
          <h3 class="md-title" style="flex:1; margin-left:10px;">
            <p v-if="service_estimate.service_estimate_status==0" style="text-align: left; font-weight:bold;">REGISTERED</p>
            <p v-if="service_estimate.service_estimate_status==1" style="text-align: left; font-weight:bold;">WAITING APPROVAL</p>
            <p v-if="service_estimate.service_estimate_status==2" style="text-align: left; font-weight:bold;">APPROVED</p>
            <p v-if="service_estimate.service_estimate_status==3" style="text-align: left; font-weight:bold;">REJECTED</p>
          </h3>
        </div>
        <div style="width:50%">
          <div class="md-toolbar-section-end">
            <md-menu md-direction="bottom-start">
              <md-button v-if="service_estimate.service_estimate_status!=2 && service_estimate.service_estimate_status!=3" class="nonprint; md-dense color" md-menu-trigger>Change Status</md-button>
              <md-menu-content>
                <md-menu-item v-if="service_estimate.service_estimate_status==0 && role.requester" class="noprint" @click="updateStatusConfirmation('Request Approval')">Request Approval</md-menu-item>
                <md-menu-item v-if="service_estimate.service_estimate_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation('Approve')">Approve</md-menu-item>
                <md-menu-item v-if="service_estimate.service_estimate_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation('Reject', true)">Reject</md-menu-item>
              </md-menu-content>
            </md-menu>
            <md-button class="noprint md-dense md-icon-button color" @click="printPage()" ><md-icon>print</md-icon></md-button>
            <md-button style="float:right;" class="md-icon-button md-dense color color" @click="closeDetail()"><md-icon>close</md-icon></md-button>
          </div>
        </div>
      </md-toolbar> -->
      <div class="md-layout-item md-size-100 md-small-size-100" style="margin-top:20px;">
        <md-card>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head><b>Service Estimate No</b></md-table-head>
                <md-table-head><b>Tanggal Estimate</b></md-table-head>
                <md-table-head><b>PPN</b></md-table-head>
                <md-table-head><b>Guarantee</b></md-table-head>
                <md-table-head><b>Service Advisor</b></md-table-head>
              </md-table-row>
              <md-table-row>
                <md-table-cell>{{service_estimate.service_estimate_no}}</md-table-cell>
                <md-table-cell>{{service_estimate.service_estimate_create_at_datetime}}</md-table-cell>
                <md-table-cell > 
                  <p v-if="service_estimate.service_estimate_ppn==1">No</p>
                  <p v-if="service_estimate.service_estimate_ppn==0">Yes</p>
                </md-table-cell>
                <md-table-cell>
                  <p v-if="service_estimate.service_estimate_guarantee == 1">Under Guarantee</p>
                  <p v-else>Not Under Guarantee</p>
                </md-table-cell>
                <md-table-cell>{{service_estimate.service_estimate_service_advisor_name.name}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div  class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 1" class="title">Client</h4>
              <h4 v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 2" class="title">Client/Driver</h4>
              <h4 v-if="service_estimate.service_estimate_type == 2" class="title">Customer</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table>
              <md-table-row v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 1">
                <md-table-cell style="font-weight:bold;">Client No</md-table-cell>
                <md-table-cell>{{ service_estimate.service_estimate_client.client_no}}</md-table-cell>
              </md-table-row>
              <md-table-row v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 2">
                <md-table-cell style="font-weight:bold;">Driver No</md-table-cell>
                <md-table-cell>{{ service_estimate.service_estimate_client.driver_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Name</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 1">{{ service_estimate.service_estimate_client.client_name}}</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 2">{{ service_estimate.service_estimate_client.driver_name}}</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 2">{{ service_estimate.service_estimate_vehicle.vehicle_external_name}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Phone</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 1">{{ service_estimate.service_estimate_client.client_phone}}</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 2">{{ service_estimate.service_estimate_client.driver_phone_no}}</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 2">{{ service_estimate.service_estimate_vehicle.vehicle_external_phone}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Email</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 1">{{ service_estimate.service_estimate_client.client_email}}</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 2">{{ service_estimate.service_estimate_client.driver_email}}</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 2">{{ service_estimate.service_estimate_vehicle.vehicle_external_email}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Address</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 1">{{ service_estimate.service_estimate_client.client_address}}</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 2">{{ service_estimate.service_estimate_client.driver_address}}</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 2">{{ service_estimate.service_estimate_vehicle.vehicle_external_address}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Vehicle</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Plat No</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type != 2">{{ service_estimate.service_estimate_customer_plate_no}}</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 2">{{ service_estimate.service_estimate_vehicle.vehicle_external_plate_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Merk/Type</md-table-cell>
                <md-table-cell >{{service_estimate.vehicle_brand_text+" "+service_estimate.vehicle_type_text}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Engine No</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type != 2">{{ service_estimate.service_estimate_engine_no}}</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 2">{{ service_estimate.service_estimate_vehicle.vehicle_external_engine_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Chassis No</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type != 2">{{ service_estimate.service_estimate_chasis_no}}</md-table-cell>
                <md-table-cell v-if="service_estimate.service_estimate_type == 2">{{ service_estimate.service_estimate_vehicle.vehicle_external_chassis_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Kilometer</md-table-cell>
                <md-table-cell>{{ service_estimate.service_estimate_vehicle_km}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      
      <div class="md-layout-item md-size-100">
        <md-card >
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Part & Material</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-primary">
                <h4 class="title">Material</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row >
                    <md-table-head style="  width:300px;"><b>Material</b></md-table-head>
                    <md-table-head style=""><b>LTS</b></md-table-head>
                    <md-table-head style=""><b>Price</b></md-table-head>
                    <md-table-head style=""><b>Discount(%)</b></md-table-head>
                    <md-table-head style=" width:300px;"><b>Remark</b></md-table-head>
                    <md-table-head style=""><b>Total</b></md-table-head>
                  </md-table-row>
                  <md-table-row v-for="(item, index)  in service_estimate.service_estimate_service" :key="index">
                    <md-table-cell style=" width:300px;">{{ item.service_master_name }}</md-table-cell>
                    <md-table-cell>{{ item.service_master_lts }}</md-table-cell>
                    <md-table-cell>{{ formatPrice(item.service_category_standard_cost) }}</md-table-cell>
                    <md-table-cell>
                      <p v-if="item.service_estimate_service_discount">
                      {{ item.service_estimate_service_discount }}%
                      </p>
                      <p v-else></p>
                    </md-table-cell>
                      <md-table-cell style="width:300px">{{ item.service_estimate_service_remark }}</md-table-cell>
                      <md-table-cell>
                        <p v-if="item.service_estimate_service_discount">
                        {{ formatPrice(item.service_master_lts * item.service_category_standard_cost - ((item.service_category_standard_cost * item.service_master_lts) * item.service_estimate_service_discount / 100))}}
                        </p>
                        <p v-else>
                          {{ formatPrice(item.service_master_lts * item.service_category_standard_cost)}}
                        </p>
                      </md-table-cell>
                    </md-table-row>
                    <md-table-row>
                      <md-table-cell colspan="4"></md-table-cell>
                      <md-table-cell style="text-align: center; font-weight:bold;">Sub Total</md-table-cell>
                      <md-table-cell>
                        {{formatPrice(total_pekerjaan)}}
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>

              <md-card>
                <md-card-header class="md-card-header-text md-card-header-primary">
                <h4 class="title">Part</h4>
              </md-card-header>
                <md-card-content>
                  <md-table>
                    <md-table-row >
                      <md-table-head style=" width:300px;"><b>Spare Part</b></md-table-head>
                      <md-table-head style=""><b>Qty</b></md-table-head>
                      <md-table-head style=""><b>Price</b></md-table-head>
                      <md-table-head style=""><b>Discount(%)</b></md-table-head>
                      <md-table-head style=" width:300px;"><b>Remark</b></md-table-head>
                      <md-table-head style=""><b>Total</b></md-table-head>
                    </md-table-row>
                    <md-table-row v-for="(item, index)  in service_estimate.service_estimate_part" :key="index">
                      <md-table-cell style=" width:300px;">{{ item.part_master.spare_part_master_name }}</md-table-cell>
                      <md-table-cell>{{ item.service_estimate_spare_part_qty }}</md-table-cell>
                      <md-table-cell>
                        {{ formatPrice(item.part_master.spare_part_master_unit_price) }}
                      </md-table-cell>
                      <md-table-cell>
                        <p v-if="item.service_estimate_spare_part_discount">
                          {{ item.service_estimate_service_discount }}%
                        </p>
                        <p v-else>-</p>
                      </md-table-cell>
                      <md-table-cell style="width:300px"><p>{{ item.service_estimate_spare_part_remark }}</p></md-table-cell>
                      <md-table-cell>
                        <p v-if="item.service_estimate_spare_part_discount">
                        {{ formatPrice(item.service_estimate_spare_part_qty * item.part_master.spare_part_master_unit_price - ((item.service_estimate_spare_part_qty * item.part_master.spare_part_master_unit_price) * item.service_estimate_spare_part_discount / 100)) }}
                        </p>
                        <p v-else>
                          {{ formatPrice(item.service_estimate_spare_part_qty * item.part_master.spare_part_master_unit_price) }}
                        </p>
                      </md-table-cell>
                    </md-table-row>
                    <md-table-row>
                      <md-table-cell colspan="4"></md-table-cell>
                      <md-table-cell style="text-align:center; font-weight:bold;">Sub Total</md-table-cell>
                      <md-table-cell>
                        {{formatPrice(total_part)}}
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
              <md-card>
                <md-card-content>
                  <md-table style="width:100%">
                    <md-table-row>
                      <md-table-cell style="width:10%;"><b>Subject</b></md-table-cell>
                      <md-table-cell style="width:25%;">
                        Rp.{{formatPrice(subject)}}
                      </md-table-cell>
                      
                      <md-table-cell style="width:10%;"><b>11%PPN</b></md-table-cell>
                      <md-table-cell style="width:20%;">
                        Rp.{{formatPrice(ppn)}}
                      </md-table-cell>
                      
                      <md-table-cell style="width:20%;"><b>Total Estimate Charge</b></md-table-cell>
                      <md-table-cell style="width:15%;">
                        Rp.{{formatPrice(total_estimate)}}
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                  <!-- <table>
                    <colgroup>
                      <col style="width: 10mm">
                      <col style="width: 3mm">
                      <col style="width: 60mm">
                      <col style="width: 16mm">
                      <col style="width: 3mm">
                      <col style="width: 35mm">
                      <col style="width: 30mm">
                      <col style="width: 3mm">
                      <col style="width: 20mm">
                    </colgroup>
                    <tr>
                      <td style="font-weight:bold; font-size: 15px;">Subject</td>
                      <td style="font-size: 15px;"> :</td>
                      <td style="font-size: 15px;"><span style="float: left;">Rp</span><span>{{formatPrice(subject)}}</span></td>
                      <td style="font-weight:bold; font-size: 15px;">PPN 10%</td>
                      <td style="font-size: 15px;"> :</td>
                      <td style="font-size: 15px;"><span style="float: left;">Rp</span><span>{{formatPrice(subject)}}</span></td>
                      <td style="font-weight:bold; font-size: 15px;">Total Estimate Charge</td>
                      <td style="font-size: 15px;"> :</td>
                      <td style="font-size: 15px;"><span style="float: left;">Rp</span><span>{{formatPrice(subject)}}</span></td>
                    </tr>
                    
                    </table> -->
                </md-card-content>
              </md-card>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <div v-if="service_estimate"  class="md-layout print">
      <div class="md-layout-item md-size-100">
        <!-- <md-card class=" print" style="box-shadow:none;"> -->
          <md-content>
            <!-- <table class="noprint" style="width: 100%; text-transform: capitalize ;">
              <colgroup>
                <col style="width: 8mm">
                <col style="width: 18mm">
                <col style="width: 20mm">
                <col style="width: 119mm">
                <col style="width: 15mm">
              </colgroup>
              <tr>
                <td >Status :</td>
                <td>
                  <p v-if="service_estimate.service_estimate_status==0" style="text-align: left;">Registered</p>
                  <p  v-if="service_estimate.service_estimate_status==1" style="text-align: left;">Waiting Approval</p>
                  <p  v-if="service_estimate.service_estimate_status==2" style="text-align: left;">Approved</p>
                  <p  v-if="service_estimate.service_estimate_status==3" style="text-align: left;">Rejected</p>
                </td>
                <td>
                  <md-menu md-direction="bottom-start">
                    <md-button v-if="service_estimate.service_estimate_status!=2 && service_estimate.service_estimate_status!=3" class="nonprint; md-info" md-menu-trigger>Change Status</md-button>
                    <md-menu-content>
                      <md-menu-item v-if="service_estimate.service_estimate_status==0 && role.requester" class="noprint" @click="updateStatusConfirmation('Request Approval')">Request Approval</md-menu-item>
                      <md-menu-item v-if="service_estimate.service_estimate_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation('Approve')">Approve</md-menu-item>
                      <md-menu-item v-if="service_estimate.service_estimate_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation('Reject', true)">Reject</md-menu-item>
                    </md-menu-content>
                  </md-menu>
                </td>
                <td><md-button md-menu-trigger style="float: right;" class="noprint" @click="printPage()" ><md-icon>print</md-icon></md-button></td>
                <td >
                  <md-menu md-direction="bottom-start">
                    <md-button class="nonprint; md-info" md-menu-trigger>Option</md-button>
                    <md-menu-content>
                      <md-menu-item @click="createPkb(service_estimate.id)" 
                        v-if="!service_estimate.service_estimate_pkb && service_estimate.service_estimate_status==2">Create PKB
                      </md-menu-item>
                      <md-menu-item v-if="service_estimate.service_estimate_pkb!=null" @click="showPkb(service_estimate.service_estimate_pkb.id)">View PKB</md-menu-item>
                      <md-menu-item v-if="role.update && service_estimate.service_estimate_status == 0" @click="editServiceEstimate(service_estimate.id)">Edit</md-menu-item>
                      <md-menu-item v-if="role.delete && service_estimate.service_estimate_status == 0" @click="deleteConfirmation(service_estimate.id)">Delete</md-menu-item>
                      <md-menu-item @click="backtoList">Back to SE list</md-menu-item> 
                    </md-menu-content>
                  </md-menu>
                </td>
              </tr>
            </table> -->
            <table>
              <tr>
                <td class="print">PT Charged Tech Indonesia</td>
                <td style="text-align: right;">{{service_estimate.service_estimate_no}}</td>
              </tr>
            </table>
            <table class="print" style="border: 4px solid black; text-align: center; font-weight: 900;">
              <tr>
                <td>SERVICE ESTIMATE</td>
              </tr>
            </table>
            <table style="border-bottom: 1px solid black; margin-top:10px">
              <colgroup>
                <col style="width: 34mm">
                <col style="width: 90mm">
                <col style="width: 38mm">
                <col style="width: 18mm">
              </colgroup>
              <tr>
                <td style="font-weight: bold;">SERVICE ADVISOR :</td>
                <td>{{service_estimate.service_estimate_service_advisor_name.name}}</td>
                <td style="font-weight: bold;">TANGGAL ESTIMASI :</td>
                <td >{{service_estimate.service_estimate_create_at_datetime}}</td>
              </tr>
            </table>
            <table class="table-kotak" style="margin-top:10px">
              <colgroup>
                <col style="width: 52mm">
                <col style="width: 52mm">
                <col style="width: 30mm">
                <col >
              </colgroup>
              <tr>
                <td class="title-name" style="font-weight: bold; text-align: center;">NAMA</td>
                <td v-if="service_estimate.service_estimate_type != 2" colspan="3">{{service_estimate.service_estimate_client.client_name}}</td>
                <td v-if="service_estimate.service_estimate_type == 2" colspan="3">{{service_estimate.service_estimate_vehicle.vehicle_external_name}}</td>
              </tr>
              <tr>
                <td class="title-name" style="font-weight: bold; text-align: center;">NO. TELP</td>
                <td v-if="service_estimate.service_estimate_type != 2">{{service_estimate.service_estimate_client.client_phone}}</td>
                <td v-if="service_estimate.service_estimate_type == 2">{{service_estimate.service_estimate_vehicle.vehicle_external_phone}}</td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td class="title-name" style="font-weight: bold; text-align: center;">MEREK/TYPE</td>
                <!-- <td v-if="service_estimate.service_estimate_type != 2">{{service_estimate.vehicle_brand_text+" "+service_estimate.vehicle_type_text}}</td> -->
                <td>{{service_estimate.vehicle_brand_text+" "+service_estimate.vehicle_type_text}}</td>
                <td class="title-name" style="font-weight: bold; text-align: center;" >NO. RANGKA</td>
                <td v-if="service_estimate.service_estimate_type != 2">{{service_estimate.service_estimate_chasis_no}}</td>
                <td v-if="service_estimate.service_estimate_type == 2">{{service_estimate.service_estimate_vehicle.vehicle_external_chassis_no}}</td>
              </tr>
              <tr>
                <td class="title-name" style="font-weight: bold; text-align: center;">NO. POL</td>
                <td v-if="service_estimate.service_estimate_type != 2">{{service_estimate.service_estimate_customer_plate_no}}</td>
                <td v-if="service_estimate.service_estimate_type == 2">{{service_estimate.service_estimate_vehicle.vehicle_external_plate_no}}</td>
                <td class="title-name" style="font-weight: bold; text-align: center;">KILOMETER</td>
                <td >{{service_estimate.service_estimate_vehicle_km}}</td>
              </tr>
              <tr>
                <td class="title-name" style="font-weight: bold; text-align: center;">GARANSI</td>
                <td v-if="service_estimate.service_estimate_guarantee == 1" colspan="3">Under Guarantee</td>
                <td v-else colspan="3">Not Under Guarantee</td>
              </tr>
            </table>
            <table class="table-kotak" style="margin-top:10px">
              <colgroup>
                <col style="width: 40mm">
                <col style="width: 10mm">
                <col style="width: 25mm">
                <col style="width: 20mm">
                <col style="width: 60mm">
                <col style="width: 25mm">
              </colgroup>
              <thead>
                <tr>
                  <th class="title-name">Pekerjaan</th>
                  <th class="title-name">LTS</th>
                  <th class="title-name">Labor Price</th>
                  <th class="title-name">Diskon(%)</th>
                  <th class="title-name">Remark</th>
                  <th class="title-name">Total</th>        
                </tr>
              </thead>
              <tr v-for="(item, index)  in service_estimate.service_estimate_service"
                :key="index" >
                <!-- <td >{{ index+1 }}</td> -->
                <!-- <td >{{ item.service_category_code }}</td> -->
                <td >{{ item.service_master_name }}</td>
                <td >{{ item.service_master_lts }}</td>
                <td ><span style="float:left;">Rp.</span><span style="float:right;">{{ formatPrice(item.service_category_standard_cost) }}</span></td>
                <td  style="text-align: right;" v-if="item.service_estimate_service_discount" >{{ item.service_estimate_service_discount }}%</td>
                <td v-else ></td>
                <td >{{ item.service_estimate_service_remark }}</td>
                <td v-if="item.service_estimate_service_discount" ><span style="float: left;">Rp</span><span style="float: right;">{{ formatPrice(item.service_master_lts * item.service_category_standard_cost - ((item.service_category_standard_cost * item.service_master_lts) * item.service_estimate_service_discount / 100))}}</span></td>
                <td v-else ><span style="float: left;">Rp</span><span style="float: right;">{{ formatPrice(item.service_master_lts * item.service_category_standard_cost)}}</span></td>
              </tr>
              <tr>
                <td class="title-name" colspan="5" style="text-align: right;"><b>Sub Total</b></td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(total_pekerjaan)}}</span></td>
              </tr>
            </table>
              
            <table class="table-kotak" style="margin-top:10px">
              <colgroup>
                <col style="width: 40mm">
                <col style="width: 10mm">
                <col style="width: 25mm">
                <col style="width: 20mm">
                <col style="width: 60mm">
                <col style="width: 25mm">
              </colgroup>
              <thead>
                <tr>
                  <th class="title-name">SPARE PART</th>
                  <th class="title-name">Qty</th>
                  <th class="title-name">Parts Price</th>
                  <th class="title-name">Diskon(%)</th>
                  <th class="title-name">Remark</th> 
                  <th class="title-name">Total</th>       
                </tr>
              </thead>
              <tr v-if="service_estimate.service_estimate_part.length==0">
                <td colspan="5" style="text-align:center"> NO SPARE PART ARE SELECTED </td>
              </tr>
              <tr v-else v-for="(item, index)  in service_estimate.service_estimate_part"
                :key="index" >
                <!-- <td >{{ index+1 }}</td> -->
                <!-- <td >{{ item.service_category_code }}</td> -->
                <td >{{ item.part_master.spare_part_master_name }}</td>
                <td >{{ item.service_estimate_spare_part_qty }}</td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{ formatPrice(item.part_master.spare_part_master_unit_price) }}</span></td>
                <td  style="text-align: right;" v-if="item.service_estimate_spare_part_discount" >{{ item.service_estimate_spare_part_discount }}%</td>
                <td v-else ></td>
                <td >{{ item.service_estimate_spare_part_remark }}</td>
                <td v-if="item.service_estimate_spare_part_discount"><span style="float: left;">Rp</span><span style="float: right;">{{ formatPrice(item.service_estimate_spare_part_qty * item.part_master.spare_part_master_unit_price - ((item.service_estimate_spare_part_qty * item.part_master.spare_part_master_unit_price) * item.service_estimate_spare_part_discount / 100)) }}</span></td>
                <td v-else><span style="float: left;">Rp</span><span style="float: right;">{{ formatPrice(item.service_estimate_spare_part_qty * item.part_master.spare_part_master_unit_price) }}</span></td>
                
              </tr>
              <tr>
                <td class="title-name" colspan="5" style="text-align: right;"><b>Sub Total</b></td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(total_part)}}</span></td>
              </tr>
            </table>
                  
            <table class="table-kotak" style="margin-top:10px">
              <colgroup>
                <col style="width: 65mm">
                <col style="width: 10mm">
                <col style="width: 30mm">
                <col style="width: 30mm">
                <col >
              </colgroup>
              <tr>
                <td class="title-name" colspan="4" style="text-align: right;"><b>Subject</b></td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(subject)}}</span></td>
              </tr>
              <tr>
                <td class="title-name" colspan="4" style="text-align: right;"><b>PPN 11%</b></td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(ppn)}}</span></td>
              </tr>
            </table>
                  
            <table class="table-kotak" style="margin-top:10px">
              <colgroup>
                <col style="width: 65mm">
                <col style="width: 10mm">
                <col style="width: 30mm">
                <col style="width: 30mm">
                <col >
              </colgroup>
              <tr>
                <td class="title-name" colspan="4" style="text-align: right;"><b>Total Estimated Charge</b></td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(total_estimate)}}</span></td>
              </tr>
            </table>

            <table class="print" style="margin-top:5px;">
              <td style="text-align: right; font-weight: bold; padding-right:10px;">Valid of this estimation : 2(two) week</td>
            </table>
            <table class="print" style="margin-top:10px;">
              <colgroup>
                <col style="width: 90mm">
                <col style="width: 90mm">
              </colgroup>
              <tr>
                <td style="text-align: center;">DIPERIKSA OLEH ,</td>
                <td style="text-align: center;">PENERIMA ,</td>
                
              </tr>
              <tr>&zwnj;</tr>
              <tr>&zwnj;</tr>
              <tr>&zwnj;</tr>
              <tr>
                <td style="text-align: center;"><sub>(</sub><span style="display:inline-block; border-bottom:1px solid black; padding-left:10px; min-width:200px;  padding-right:10px; padding-top:0px">{{service_estimate.service_estimate_service_advisor_name.name}}&zwnj;</span><sub>)</sub></td>
                <td v-if="service_estimate.service_estimate_type != 2" style="text-align: center;"><sub>(</sub><span style="display:inline-block; border-bottom:1px solid black; padding-left:10px; min-width:200px; padding-right:10px;">{{service_estimate.service_estimate_client.client_name}}&zwnj;</span><sub>)</sub></td>
                <td v-if="service_estimate.service_estimate_type == 2" style="text-align: center;"><sub>(</sub><span style="display:inline-block; border-bottom:1px solid black; padding-left:10px; min-width:200px; padding-right:10px;">{{service_estimate.service_estimate_vehicle.vehicle_external_name}}&zwnj;</span><sub>)</sub></td>
              </tr>
              <tr>
                <td style="text-align: center;">SERVICE ADVISOR</td>
                <td style="text-align: center;">CUSTOMER</td>
              </tr>
            </table>
          </md-content>
      </div></div>
        <!-- </md-card> -->
        <!-- <button class="noprint" @click="printInvoice" >Print Invoice</button>
        <button class="noprint" @click="generateReport" >Print Invoice</button> -->
       
          
    <div v-bind:style="{ display: not_found}">
      <center  v-if="service_estimate ||service_estimate == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Go to List?</a>
        </p>
      </center>
    </div>
    </div>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Swal from 'sweetalert2';

// import InfoCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/InfoCard.vue";
// import ClientCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ClientCard.vue";
// import VehicleCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/VehicleCard.vue";
// import ServiceCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ServiceCard.vue";
// import PartCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/PartCard.vue";
import Vue from "vue";
export default {
  name: "detail-service-estimates",

  // props: {
  //   service_estimate: Object,
  // },

  components: {
    // ValidationError,
    // FormWizard,
    // TabContent,
    // "info-card": InfoCard,
    // "client-card": ClientCard,
    // "vehicle-card": VehicleCard,
    // "service-card": ServiceCard,
    // "part-card": PartCard,
  },

  props: {
    data_id: null,
    },

  mixins: [formMixin],

  data: () => ({
    not_found: 'none',
    role:"",
    service_estimate: null,
    total_pekerjaan: 0,
    total_part: 0,
    subject: 0,
    ppn: 0,
    total_estimate: 0
  }),

  created() {
    this.getServiceEstimateData();
  },

  methods: {
    //fungsi yang berjalan saat page pertamakali dibuka
    async getServiceEstimateData(){
      //ambil list role permission user
      this.role =  await this.$store.getters["role_permission/route_filter"]
      console.log(this.role)
      //ambil data se sesuai dengan id yang ikut juga dikirim melalui route
      await this.$store.dispatch("workshop_service_estimate/get", this.data_id.id)
      this.service_estimate = await this.$store.getters["workshop_service_estimate/service_estimate"]

       //check apakah data dari api ada
        if(!this.service_estimate){
          //jika tidak ada munculkan bagian not found yang defaultnya di hide
          this.not_found = "block"
          return
        }
      //console.log(await this.$store.getters["workshop_service_estimate/service_estimate"])
      //check apakah data yang dikirim dari server ada
      
        //set var sesuai dengan data yang dikirim dari server
        if(this.service_estimate.service_estimate_vehicle){ 
          this.service_estimate.service_estimate_customer_plate_no = this.service_estimate.service_estimate_vehicle.vehicle_plate_no
          this.service_estimate.service_estimate_chasis_no =  this.service_estimate.service_estimate_vehicle.vehicle_chassis_no
          this.service_estimate.service_estimate_engine_no =  this.service_estimate.service_estimate_vehicle.vehicle_engine_no
          this.service_estimate.vehicle_brand_text = this.service_estimate.service_estimate_vehicle.vehicle_types.vehicle_brands.vehicle_brand_name
          this.service_estimate.vehicle_type_text = this.service_estimate.service_estimate_vehicle.vehicle_types.vehicle_model+' - '+ this.service_estimate.service_estimate_vehicle.vehicle_types.vehicle_year_model
          this.service_estimate.service_estimate_vehicle_text = this.service_estimate.vehicle_brand_text+' '+this.service_estimate.vehicle_type_text
        }
       
        var total_pekerjaan = 0;
        //hitung biaya total pekerjaan
        this.service_estimate.service_estimate_service.map(function(value, key) {
          if(value.service_estimate_service_discount){
           total_pekerjaan = total_pekerjaan + (value.service_master_lts * value.service_category_standard_cost - ((value.service_master_lts * value.service_category_standard_cost) * value.service_estimate_service_discount / 100))
          }
          else{
            total_pekerjaan = total_pekerjaan + (value.service_master_lts * value.service_category_standard_cost) 
          }
          
        });
        this.total_pekerjaan = total_pekerjaan

        var total_part = 0;
        //hitung biaya total part
        this.service_estimate.service_estimate_part.map(function(value, key) {
          if(value.service_estimate_spare_part_discount){
             total_part = total_part + (value.spare_part_master_unit_price * value.service_estimate_spare_part_qty - ((value.spare_part_master_unit_price * value.service_estimate_spare_part_qty) * value.service_estimate_spare_part_discount / 100))
          }
          else{
            total_part = total_part + (value.part_master.spare_part_master_unit_price * value.service_estimate_spare_part_qty)
          }
          
        });
        this.total_part = total_part
        this.subject = total_part + total_pekerjaan
        
        //check apakah menggunakan ppn
        console.log(this.service_estimate.service_estimate_ppn);
        if(this.service_estimate.service_estimate_ppn == 0){
          //jika iya hitung ppn nya, ppn 11%
          this.ppn = this.subject *  (11 / 100)
        }
        //set total estimate
        this.total_estimate = this.ppn + this.subject
      
        
    },

    async closeDetail(){
      this.$parent.$parent.modalCloseDetail();
    },

    // fungsi currency number
    formatPrice(value) {
      let val = (value/1).toFixed().replace('.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    // direct ke edit form
    editServiceEstimate(id) {
      //pindah ke page edit, id juga ikut dikirim melalui route
      this.$router.push({ name: 'Edit Service Estimate', params: {service_estimate: id, id } })
    },
    
    // direct ke detail pkb page
    showPkb(id) {
      //pindah ke detail page, id juga ikut dikirim melalui route
      this.$router.push({name: 'Detail PKB', params: { service_estimate: id, id }})
    },
    
    // direct ke list view table
    backtoList() {
      //kembali ke list
      this.$router.replace({ name: 'List Service Estimate'})
    },

    // direct ke add form
    async createPkb(id) {
      //pindah ke page create pkb, id juga ikut dikirim melalui route
      this.$router.push({ name: 'Add PKB',  query: { service_estimate:id } })
    },

    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.deleteServiceEstimate(id)
        }
      });
    },
    
    // fungsi delete data
    async deleteServiceEstimate(id) {
      try {
        //kirim data ke server
        await this.$store.dispatch("workshop_service_estimate/destroy", id)
        //panggil alert succes
        await this.$store.dispatch("alerts/success", "User data delete successfully.")
        //kembali ke page list
        this.$router.replace({ name: 'List Service Estimate'})
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
        this.setApiValidation(e.response.data.errors)
      }
    },

    // validasi perubahan status
    updateStatusConfirmation(text,rejected_status) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, '+text+' it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.updateStatus(rejected_status)
        }
      });
    },
    
    // fungsi update status
    async updateStatus(rejected_status) {
      console.log("sdad")
      var rejected = false
      if(rejected_status==true){
        rejected = true
      }
      const data = {
        type: "workshop_service_estimates",
        id:this.service_estimate.id,
        current_status:this.service_estimate.service_estimate_status,
        rejected:rejected
      }

      console.log(data)
      try {
        //kirim data keserver
        await this.$store.dispatch("workshop_service_estimate/update_status", data);
        //panggil alert succes
        await this.$store.dispatch(
        "alerts/success",
        "Status Successfully update."
      );
      // await this.$router.push({name: 'List Service Estimate'}{name: 'Detail Service Estimate', params: { id: service_estimate.id }});
      // await this.$router.push({name: 'List Service Estimate'});
      this.getServiceEstimateData();
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
        "alerts/error",
        "Oops, something went wrong"
        );
      }

    },
    
    // direct ke list view table
    async backToList(){
      await this.$router.replace({name: 'List Service Estimate'})
    },
    
    printPage(){
      window.print()
    }
      
  }
};
</script>
<style scoped>
.title-name{
  background-color:powderblue;
}
table{
  width:100%;
  table-layout: fixed;
}
.table-kotak{
  border-collapse: collapse;
}
table.table-kotak td{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
table.table-kotak th{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print{
  visibility: hidden;
}
@media print{
   .print{
       visibility: visible;
       zoom: 80%;
      margin: none;
   }
   .noprint{
     display: none;
   }
   /* content {transform: scale(.5);}
    .md-card {page-break-inside: avoid;} */

  
}

/* .md-layout{
  background-color: white;
} */

.md-card{
  box-shadow: 0 3px 5px 1px rgb(0 0 0/ 14%);
 
}

.color{
  background-color: #1976d2 !important;
}

</style>